// Site-wide accessibility fixes from the launch test (3 Nov)
(() => {
  // Phone menu: Escape closes it and puts focus back on the menu button; each dropdown says whether it is open
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) { toggle.click(); toggle.focus(); }
    });
    nav.querySelectorAll('.has-dropdown').forEach((item) => {
      const link = item.querySelector(':scope > .site-nav__link');
      if (!link) return;
      const sync = () => link.setAttribute('aria-expanded', String(item.classList.contains('is-expanded')));
      sync();
      new MutationObserver(sync).observe(item, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Review stars (Appio) are icon-font glyphs ("¤" and "£") that screen readers read out letter by letter:
  // each rating becomes one image with a plain label, e.g. "Rated 4.9 out of 5 from 65 reviews"
  const label = (badge) => {
    // card badges carry data-rating / data-raters; the product page's big badge only has the text ("4.9 (65 reviews)")
    const rating = badge.dataset.rating || badge.querySelector('.appio-rating')?.textContent.trim();
    if (!rating) return;
    const count = badge.dataset.raters || (badge.textContent.match(/(\d[\d,]*)\s*review/i) || [])[1];
    const text = `Rated ${rating} out of 5${count ? ` from ${count} reviews` : ''}`;
    if (badge.getAttribute('aria-label') !== text) { badge.setAttribute('role', 'img'); badge.setAttribute('aria-label', text); }
    badge.querySelectorAll('.appio-rating-layers, .appio-stars').forEach((el) => { if (el.getAttribute('aria-hidden') !== 'true') { el.removeAttribute('role'); el.setAttribute('aria-hidden', 'true'); } });
  };
  let queued = false;
  // badges are few, so every sweep relabels all of them (Appio sometimes redraws a badge it has already drawn)
  const sweep = () => { queued = false; document.querySelectorAll('.appio-rating-badge').forEach(label); };
  // Appio draws its badges after the page loads (and again when cards are added), so watch for them
  new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(sweep); } }).observe(document.body, { childList: true, subtree: true });
  sweep();
})();
